"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _SessionData_instance, _SessionData_responseDto;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionData = void 0;
const viewer_shared_node_tree_1 = require("@shapediver/viewer.shared.node-tree");
class SessionData extends viewer_shared_node_tree_1.AbstractTreeNodeData {
    constructor(responseDto, instance = false, id, version) {
        super(id, version);
        _SessionData_instance.set(this, false);
        _SessionData_responseDto.set(this, void 0);
        __classPrivateFieldSet(this, _SessionData_responseDto, responseDto, "f");
        __classPrivateFieldSet(this, _SessionData_instance, instance, "f");
    }
    get instance() {
        return __classPrivateFieldGet(this, _SessionData_instance, "f");
    }
    set instance(value) {
        __classPrivateFieldSet(this, _SessionData_instance, value, "f");
    }
    get responseDto() {
        return __classPrivateFieldGet(this, _SessionData_responseDto, "f");
    }
    set responseDto(value) {
        __classPrivateFieldSet(this, _SessionData_responseDto, value, "f");
    }
    clone() {
        return new SessionData(this.responseDto, this.instance, this.id, this.version);
    }
}
exports.SessionData = SessionData;
_SessionData_instance = new WeakMap(), _SessionData_responseDto = new WeakMap();
//# sourceMappingURL=SessionData.js.map